import {ChartAggOption} from '../../../generated/graphql';
import {Line} from '../../../util/plotHelpers/types';
import {BIN_POINT_TO_USE} from './../../../util/plotHelpers/chartTypes';
import {PointWithMeta} from './buildPoints';
import {parseHistory} from './parseHistory';
import {HistoryRecord, LineAggregation} from './types';

export function addSmoothedLineFromBackend(
  line: Line,
  {
    agg,
    behavior,
    smoothedMetric,
    finitePoints,
    groupAgg,
    isRunsetGrouped,
    matchedHistory,
    xAxis,
    xMetrics,
  }: {
    agg: LineAggregation;
    behavior: {
      usingExpressions: boolean;
    };
    smoothedMetric: string;
    finitePoints: PointWithMeta[];
    isRunsetGrouped: boolean;
    groupAgg?: ChartAggOption;
    matchedHistory: Record<string, any>[];
    xAxis: string;
    xMetrics: string[];
  }
) {
  const finiteByX = new Map<number, PointWithMeta>();
  finitePoints.forEach(p => {
    finiteByX.set(p.x, p);
  });

  const smoothedPoints = parseHistory(
    matchedHistory as HistoryRecord[],
    smoothedMetric,
    xAxis,
    xMetrics.filter(x => x !== xAxis),
    {
      agg,
      startTime: {
        value: line.startTimeInMs!,
        unit: 'milliseconds',
      },
      usingExpressions: behavior.usingExpressions,
    },
    // we don't allow targeting min/max outside of groups currently
    isRunsetGrouped
      ? groupAgg
      : (BIN_POINT_TO_USE.toLowerCase() as ChartAggOption)
  );

  // Create a complete smoothed line.
  const smoothedLine: Line = {
    ...line,
    smoothed: true,
    meta: {
      ...line.meta,
      category: 'smoothed',
    },
    data: smoothedPoints.finitePoints.map(p => ({
      x: p.x,
      y: p.y,
      legendData: {
        original: finiteByX.get(p.x)?.y,
      },
    })),
  };

  line.smoothedLineFromBackend = smoothedLine;
}
